export const CACHE_SYNC_ERROR = 'CACHE_SYNC_ERROR';
export const CACHE_SYNC_REQUEST = 'CACHE_SYNC_REQUEST';
export const CACHE_SYNC_SUCCESS = 'CACHE_SYNC_SUCCESS';
